// Re-export shim: this component now lives in the shared @atomic/ui-kit package.
// Kept locally only so existing "components/ui/*" import paths keep resolving.

export { Textarea, type TextareaProps } from "@atomic/ui-kit";
